var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('section',{staticClass:"sitemap"},[_c('h1',[_vm._v("Sitemap")]),_vm._v(" "),_c('Tree',{attrs:{"items":_vm.items}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }